// src/components/AddToHomeScreenGate.jsx
import React from "react";

import i18n from "../i18n";
const tr = i18n.t.bind(i18n);
function isIOS() { return /iPhone|iPad|iPod/.test(navigator.userAgent); }
function isStandalone() {
  // iOS: either display-mode: standalone or legacy navigator.standalone
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

export default function AddToHomeScreenGate({ onContinueInBrowser, onInstalled }) {
  if (!isIOS() || isStandalone()) return null;

  return (
    <div style={overlayStyle}>
      <div style={cardStyle}>
        <h2 style={{ marginTop: 0 }}>{tr('Install to Home Screen')}</h2>
        <p style={{ margin: "8px 0 16px" }}>{tr(
          'To get notifications and the best experience, add this app to your Home Screen.'
        )}</p>

        <ol style={{ textAlign: "left", lineHeight: 1.5, margin: "0 0 16px 18px" }}>
          <li>{tr('Tap the')}<b>{tr('Share')}</b>{tr('icon in Safari.')}</li>
          <li>{tr('Choose')}<b>{tr('Add to Home Screen')}</b>.</li>
          <li>{tr('Open the app from the new icon.')}</li>
        </ol>

        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
          <button onClick={() => onInstalled?.()} style={primaryBtn}>{tr('I installed it')}</button>
          <button onClick={onContinueInBrowser} style={ghostBtn}>{tr('Continue in browser')}</button>
        </div>

        <div style={{ fontSize: 12, color: "#6b7280", marginTop: 12 }}>{tr(
          'You can still use the app in Safari; notifications will work only after installing.'
        )}</div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed", inset: 0, background: "rgba(0,0,0,.5)",
  display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
};
const cardStyle = {
  width: "min(520px, 92%)", background: "#fff", borderRadius: 16,
  padding: 20, boxShadow: "0 10px 30px rgba(0,0,0,.25)", textAlign: "center"
};
const primaryBtn = {
  padding: "10px 14px", borderRadius: 10, border: 0, background: "#2563eb", color: "#fff", cursor: "pointer"
};
const ghostBtn = {
  padding: "10px 14px", borderRadius: 10, border: "1px solid #d1d5db", background: "#fff", cursor: "pointer"
};
